//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import util from '@/libs/util.js';
// import fileUploader from '@/views/common-components/file-uploader.vue';

import SelectMemberModal from '../coupons/components/select-member-modal';

export default {
    name: 'shopList',
    components: { SelectMemberModal },
    data() {
        const vm = this;
        return {
            loading: false,
            saving: false,
            columns: [
                {
                    type: 'index', align: 'center', width: 60
                },
                {
                    key: 'name', title: '名称', align: 'center',
                    render(h, params) {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click: function() {
                                    vm.$router.push({
                                        path: '/shopInfo/' + row.id
                                    });
                                }
                            }
                        }, row.name));
                        return h('div', actions);
                    }
                },
                {
                    key: 'shopType', align: 'center', title: '类型',
                    render(h, params) {
                        const row = params.row;
                        if (row.shopType == 0) {
                            return h('span', '积分商城');
                        } else {
                            return h('span', '线下实体店');
                        }
                    }
                },
                {
                    key: 'contacts', align: 'center', title: '联系人'
                },
                {
                    key: 'contactNumber', align: 'center', title: '联系电话'
                },
                {
                    key: 'actions', align: 'center', title: '操作', width: 170,
                    render(h, params) {
                        const row = params.row;
                        const actions = [];
                        if (row.shopType == 0) {
                            return h('div', actions);
                        }
                        if (vm.hasPermission('Pages.ShoppingMallManage.Shop.Edit')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: function() {
                                        vm.editShop(row);
                                    }
                                }
                            }, '编辑'));
                        }
                        if (vm.hasPermission('Pages.ShoppingMallManage.Shop.Delete')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginLeft: '5px'
                                },
                                on: {
                                    click() {
                                        vm.delShop(row);
                                    }
                                }
                            }, '删除'));
                        }

                        return h('div', actions);
                    }
                }
            ],
            name: '',
            showShopEditModal: false,
            shopEditTitle: '添加',
            shop: {},
            shopRules: {
                name: { required: true, message: '请输店铺名', trigger: 'blur' },
                shopkeeperName: { required: true, message: '请选择店主', trigger: 'blur' }
                // shopType: { required: true, message: '请选择店主', trigger: 'blur' },
            },
            shopTypes: [
                // {
                //     id: 0,
                //     value: '积分商城'
                // },
                {
                    id: 1,
                    value: '线下实体店'
                }
            ],
            res_c: [],
            shopImageType: 'ShopPicture',
            showAddUserModal: false
        };
    },
    methods: {
        pageChange(page) {
            this.$store.commit('shop/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pageSize) {
            this.$store.commit('shop/setPageSize', pageSize);
            this.getPage();
        },
        getPage() {
            this.loading = true;
            this.$store.dispatch({
                type: 'shop/getAll',
                data: {
                    name: this.name
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        editShop(shop) {
            this.shop = shop;
            console.log(this.shop);
            this.shopEditTitle = shop.id > 0 ? '编辑' : '添加';
            this.res_c = [];
            this.showShopEditModal = true;
            if (shop.id > 0) {
                if (this.shop.province != '' && this.shop.province != null) {
                    this.res_c.push(this.shop.province);
                }
                if (this.shop.city != '' && this.shop.city != null) {
                    this.res_c.push(this.shop.city);
                }
                if (this.shop.county != '' && this.shop.county != null) {
                    this.res_c.push(this.shop.county);
                }
                if (this.shop.town != '' && this.shop.town != null) {
                    this.res_c.push(this.shop.town);
                }
            }

        },
        saveShop() {
            console.log(this.res_c);
            if (this.res_c[0] != undefined) {
                this.shop.province = this.res_c[0].code;
                this.shop.city = this.res_c[1].code;
                this.shop.county = this.res_c[2].code;
                this.shop.town = this.res_c[3].code;
                this.shop.address = this.res_c[0].name + this.res_c[1].name + this.res_c[2].name + this.res_c[3]
                    .name;
            }
            console.log(this.shop);
            this.$refs.shopForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    this.$store.dispatch({
                        type: 'shop/saveShop',
                        data: this.shop
                    }).then(() => {
                        this.showShopEditModal = false;
                        this.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        delete(shop) {
            this.$store.dispatch({
                type: 'shop/delShop',
                id: shop.id
            }).then(() => {
                this.$Notice.success({
                    duration: 3,
                    title: shop.name + '已删除'
                });
                this.getPage();
            });
        },
        delShop(shop) {
            this.$Modal.confirm({
                title: '删除确认',
                content: '您确定要删除' + shop.name + '吗？',
                onOk: () => {
                    this.delete(shop);
                },
                onCancel: () => {
                }
            });
        },
        showAddUser() {
            this.showAddUserModal = true;
        },
        addUser(user) {
            this.shop.shopkeeperName = user.name;
            this.shop.contacts = user.name;
            this.shop.shopkeeper = user.id;
            this.shop.contactNumber = user.phoneNumber;
            this.showAddUserModal = false;
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
    },
    computed: {
        placeholderDate() {
            return this.$t('placeholderDate');
        },
        shops() {
            return this.$store.state.shop.shops;
        },
        totalCount() {
            return this.$store.state.shop.totalCount;
        },
        currentPage() {
            return this.$store.state.shop.currentPage;
        },
        pageSize() {
            return this.$store.state.shop.pageSize;
        }
    },
    mounted() {

    }

};
